import {
  ICalculationSignalRResult
} from "@/pages-components/products/digital-offset-price/interfaces/calculation-signalr-result";
import {ICalculatedWorkFlow, IExceptionsLog} from "@/widgets/product-pricing-widget/interface";
import { usePolling } from "@/hooks/polling/use-polling";
import { POLLING_INTERVALS } from "@/hooks/polling/polling-intervals";
import { useState } from "react";

const useCalculationSocketIO = () => {
  const [signalRPricingResult, setSignalRPricingResult] = useState<any>();
  const [startCalculationData, setStartCalculationData] = useState<any>();
  const [newDieCutSelect, setNewDieCutSelect] = useState<any>();
  const [signalRWorkFlows, setSignalRWorkFlows] =
      useState<ICalculationSignalRResult>();
  const [updatedSelectedWorkFlow, setUpdatedSelectedWorkFlow] =
      useState<ICalculatedWorkFlow>();
  const [calculationExceptionsLogs, setCalculationExceptionsLogs] =
      useState<IExceptionsLog[]>();
  const [calculationServerError, setCalculationServerErrorState] =
      useState(false);
  const [isCalculationFinished, setIsCalculationFinished] = useState(false);

  const { connectionId } = usePolling({
    intervalMs: POLLING_INTERVALS.calculation,
    events: {
      updateWorkFlows: (newData) => {
        setSignalRWorkFlows(newData as ICalculationSignalRResult);
      },
      startCalculationSession: (newData) => {
        setStartCalculationData(newData);
      },
      updateSelectedWorkFlow: (_newData) => {
        //setUpdatedSelectedWorkFlow(newData);
        //setIsChangePriceForEdit(true)
      },
      UpdatePricing: (_newData) => {
        //setSignalRPricingResult(newData);
      },
      calculationFinished: (_newData) => {
        //newData.isCalculationFinished = true;
        //setSignalRPricingResult(newData);
      },
      calculationServerError: () => {
        //setCalculationServerErrorState(true);
      },
      updateDieCutSelect: (newData) => {
        setNewDieCutSelect(newData);
      },
    },
  });

  return {
    calculationResult: signalRWorkFlows,
    connectionId,
    startCalculationData,
    updatedSelectedWorkFlow,
    calculationExceptionsLogs,
    signalRPricingResult,
    calculationServerError,
    isCalculationFinished,
    newDieCutSelect,
    setIsCalculationFinished,
  };
};

export { useCalculationSocketIO };
